import React from "react";
import _ from "underscore";
class TableColumnChooser extends React.Component {
  state = {
    selectedColumns: this.props.selectedColumns
  };
  containsPrimaryColumn = columns => {
    if (this.props.primaryIds.length === 0) {
      return true;
    }
    return _.some(columns, col => _.contains(this.props.primaryIds, col));
  };
  updateBox = event => {
    if (event.target.checked) {
      const selectedColumns = this.state.selectedColumns.concat(parseInt(event.target.value, 10));
      if (selectedColumns.length > this.props.maxColumns) {
        this.props.logInfo(this.props.language.get("nc_object_list_column_chooser_max_columns", this.props.maxColumns));
        return;
      }
      this.props.updateColumns(event.target.value, false);
      this.setState({
        selectedColumns
      });
    } else {
      if (this.state.selectedColumns.length === 1) {
        this.props.logInfo(this.props.language.get("nc_column_chooser_at_least_one_column_needed"));
        return;
      }
      const deselectedId = parseInt(event.target.value, 10);
      const selectedColumns = _.without(this.state.selectedColumns, deselectedId);
      if (!this.containsPrimaryColumn(selectedColumns)) {
        if (_.contains(this.props.primaryIds, deselectedId)) {
          // Prevent deselection of the last selected primary column, but don't prevent deselecting other columns. Escape hatch for error situations like DEV-5174
          this.props.logInfo(this.props.language.get("nc_object_list_column_chooser_info"));
          return;
        }
      }
      this.props.updateColumns(event.target.value, true);
      this.setState({
        selectedColumns
      });
    }
  };
  splitColumns(allColumns) {
    let result = [[], [], []];
    allColumns.forEach(column => {
      if (column.isType) {
        result[1].push(column);
      } else if (column.isField) {
        result[2].push(column);
      } else {
        result[0].push(column);
      }
    });
    return result;
  }
  render() {
    const numberOfOptions = this.props.allColumns.length;
    let style = "oneColumn";
    if (numberOfOptions > 10 && numberOfOptions <= 20) {
      style = "twoColumns";
    } else if (numberOfOptions > 20) {
      style = "threeColumns";
    }
    const sections = this.splitColumns(this.props.allColumns);
    return /*#__PURE__*/React.createElement("div", {
      className: `columnChooserList ${style}`
    }, sections.map((section, index) => {
      if (section.length === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement("ul", {
        key: String(index)
      }, this._renderColumnItems(section));
    }));
  }
  _renderColumnItems = columns => columns.map(column => {
    const classes = {
      primaryColumns: column.primary
    };
    return /*#__PURE__*/React.createElement("li", {
      key: column.id
    }, /*#__PURE__*/React.createElement("label", {
      className: _.classSet(classes)
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      disabled: column.disabled || false,
      checked: _.contains(this.state.selectedColumns, column.id),
      name: column.name,
      onChange: this.updateBox,
      value: column.id
    }), column.name));
  });
}
export default TableColumnChooser;